const isCompactModeEnabled = state => state.timelineState.compactMode;

export default {
  isCompactModeEnabled
};
